var cov_12qvaznebu = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Pagination/Next.tsx",
      hash = "d86362432034b7fe80debd31fc47b26a8a6e7826",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Pagination/Next.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 21
        },
        end: {
          line: 11,
          column: 31
        }
      },
      "1": {
        start: {
          line: 12,
          column: 16
        },
        end: {
          line: 12,
          column: 23
        }
      },
      "2": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 15,
          column: 5
        }
      },
      "3": {
        start: {
          line: 14,
          column: 6
        },
        end: {
          line: 14,
          column: 42
        }
      },
      "4": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 41
        }
      },
      "5": {
        start: {
          line: 20,
          column: 77
        },
        end: {
          line: 20,
          column: 87
        }
      },
      "6": {
        start: {
          line: 21,
          column: 16
        },
        end: {
          line: 21,
          column: 43
        }
      },
      "7": {
        start: {
          line: 22,
          column: 17
        },
        end: {
          line: 22,
          column: 28
        }
      },
      "8": {
        start: {
          line: 23,
          column: 22
        },
        end: {
          line: 23,
          column: 74
        }
      },
      "9": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 28,
          column: 5
        }
      },
      "10": {
        start: {
          line: 32,
          column: 0
        },
        end: {
          line: 32,
          column: 43
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 10,
            column: 3
          }
        },
        loc: {
          start: {
            line: 10,
            column: 15
          },
          end: {
            line: 17,
            column: 3
          }
        },
        line: 10
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 3
          }
        },
        loc: {
          start: {
            line: 19,
            column: 11
          },
          end: {
            line: 29,
            column: 3
          }
        },
        line: 19
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 15,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 15,
            column: 5
          }
        }, {
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 15,
            column: 5
          }
        }],
        line: 13
      },
      "1": {
        loc: {
          start: {
            line: 14,
            column: 13
          },
          end: {
            line: 14,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 14,
            column: 13
          },
          end: {
            line: 14,
            column: 23
          }
        }, {
          start: {
            line: 14,
            column: 27
          },
          end: {
            line: 14,
            column: 42
          }
        }],
        line: 14
      },
      "2": {
        loc: {
          start: {
            line: 16,
            column: 11
          },
          end: {
            line: 16,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 16,
            column: 11
          },
          end: {
            line: 16,
            column: 21
          }
        }, {
          start: {
            line: 16,
            column: 25
          },
          end: {
            line: 16,
            column: 41
          }
        }],
        line: 16
      },
      "3": {
        loc: {
          start: {
            line: 23,
            column: 22
          },
          end: {
            line: 23,
            column: 74
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 23,
            column: 47
          },
          end: {
            line: 23,
            column: 64
          }
        }, {
          start: {
            line: 23,
            column: 67
          },
          end: {
            line: 23,
            column: 74
          }
        }],
        line: 23
      },
      "4": {
        loc: {
          start: {
            line: 23,
            column: 22
          },
          end: {
            line: 23,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 23,
            column: 22
          },
          end: {
            line: 23,
            column: 32
          }
        }, {
          start: {
            line: 23,
            column: 36
          },
          end: {
            line: 23,
            column: 44
          }
        }],
        line: 23
      },
      "5": {
        loc: {
          start: {
            line: 25,
            column: 56
          },
          end: {
            line: 25,
            column: 78
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 56
          },
          end: {
            line: 25,
            column: 64
          }
        }, {
          start: {
            line: 25,
            column: 68
          },
          end: {
            line: 25,
            column: 78
          }
        }],
        line: 25
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Pagination/Next.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import icons from '../icons';
import Item from './Item';
import { isRTL } from '../config';

var Next =
/*#__PURE__*/
function (_ref) {
  _inherits(Next, _ref);

  var _super = _createSuper2(Next);

  function Next() {
    _classCallCheck(this, Next);

    return _super.apply(this, arguments);
  }

  _createClass(Next, [{
    key: "renderNext",
    value: function renderNext() {
      cov_12qvaznebu.f[0]++;

      var _ref2 = (cov_12qvaznebu.s[0]++, this.props),
          text = _ref2.text;

      var rtl = (cov_12qvaznebu.s[1]++, isRTL());
      cov_12qvaznebu.s[2]++;

      if (rtl) {
        cov_12qvaznebu.b[0][0]++;
        cov_12qvaznebu.s[3]++;
        return (cov_12qvaznebu.b[1][0]++, text.prev) || (cov_12qvaznebu.b[1][1]++, icons.AngleLeft);
      } else {
        cov_12qvaznebu.b[0][1]++;
      }

      cov_12qvaznebu.s[4]++;
      return (cov_12qvaznebu.b[2][0]++, text.next) || (cov_12qvaznebu.b[2][1]++, icons.AngleRight);
    }
  }, {
    key: "render",
    value: function render() {
      cov_12qvaznebu.f[1]++;

      var _ref3 = (cov_12qvaznebu.s[5]++, this.props),
          onChange = _ref3.onChange,
          current = _ref3.current,
          text = _ref3.text,
          total = _ref3.total,
          pageSize = _ref3.pageSize,
          disabled = _ref3.disabled,
          isSimple = _ref3.isSimple;

      var max = (cov_12qvaznebu.s[6]++, Math.ceil(total / pageSize));
      var next = (cov_12qvaznebu.s[7]++, current + 1);
      var className = (cov_12qvaznebu.s[8]++, (cov_12qvaznebu.b[4][0]++, text.next) || (cov_12qvaznebu.b[4][1]++, isSimple) ? (cov_12qvaznebu.b[3][0]++, "no-border arrow") : (cov_12qvaznebu.b[3][1]++, 'arrow'));
      cov_12qvaznebu.s[9]++;
      return (
        /*#__PURE__*/
        React.createElement(Item, {
          className: className,
          page: next,
          disabled: (cov_12qvaznebu.b[5][0]++, disabled) || (cov_12qvaznebu.b[5][1]++, next > max),
          onClick: onChange,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 25,
            columnNumber: 7
          }
        }, this.renderNext())
      );
    }
  }]);

  return Next;
}((React.PureComponent));

Next.displayName = void 0;
cov_12qvaznebu.s[10]++;
Next.displayName = 'ShineoutPaginationNext';
export default Next;